/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import parse from "html-react-parser";
class CommentItem extends PureComponent {
  _onDel = () => {
    const { serial, onDel } = this.props.childProps;
    onDel(serial);
  };
  render() {
    const { loginId } = this.props;
    const { title, userid, regDate, nicName, charac_img } =
      this.props.childProps;
    return (
      <Fragment>
        <ul className="reply_item">
          <li className="user_img">
            <span className="thumb">
              <img src={charac_img} />
            </span>
          </li>
          <li className="reply_writer">
            <span className="writer">{nicName}</span>
            <span className="date">{regDate}</span>
          </li>
          <li className="reply_cont">{parse(title)}</li>
          {loginId === userid ? <li onClick={this._onDel}>삭제</li> : null}
        </ul>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(CommentItem)));
